import { FC } from 'react';

type Props = {
	className?: string;
};

const OrdersEmptyIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.99988 18.0001C9.34531 18.0001 8.72002 17.736 7.46939 17.2077C4.35633 15.8927 2.7998 15.2351 2.7998 14.1291C2.7998 13.8194 2.7998 8.45162 2.7998 6M9.99988 18.0001C10.6544 18.0001 11.2797 17.736 12.5304 17.2077C15.6435 15.8927 17.1999 15.2351 17.1999 14.1291V6M9.99988 18.0001V9.48387'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.06058 8.15316L4.7236 7.02233C3.44107 6.40172 2.7998 6.09142 2.7998 5.60004C2.7998 5.10865 3.44107 4.79835 4.7236 4.17774L7.06058 3.04691C8.5029 2.34897 9.22411 2 9.99988 2C10.7756 2 11.4968 2.34896 12.9392 3.04691L15.2762 4.17774C16.5587 4.79835 17.1999 5.10865 17.1999 5.60004C17.1999 6.09142 16.5587 6.40172 15.2762 7.02233L12.9392 8.15316C11.4968 8.85111 10.7756 9.20007 9.99988 9.20007C9.22411 9.20007 8.5029 8.85111 7.06058 8.15316Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.2002 10L6.80021 10.8'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.0001 3.6001L6 7.60014'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default OrdersEmptyIcon;
